<template>
  <div>
    <tabBox :current.sync="currentTab" @search="search" />
    <!-- <videoPlayer v-if="showVideo" :show.sync="showVideo" /> -->
    <KeepAlive exclude="ShopCenterAdminWebLearnRecords">
      <component
        :is="currentComponent"
        @to-plaza="toPlaza"
        :assignType="type"
        :keyword="keyword"
      />
    </KeepAlive>
  </div>
</template>

<script>
import tabBox from "../../components/create-college/tab-box.vue";
import recommendCourse from "../../components/create-college/recommend-course.vue";
import coursePlaza from "../../components/create-college/course-plaza.vue";
import learnRecords from "../../components/create-college/learn-records.vue";
// import videoPlayer from "../../components/create-college/video-player.vue";
export default {
  name: "ShopCenterAdminWebCollegeIndex",
  components: {
    tabBox,
    recommendCourse,
    coursePlaza,
    learnRecords,
    // videoPlayer,
  },
  data() {
    return {
      currentTab: 1,
      currentComponent: "recommendCourse",
      type: "",
      keyword: "",
      showVideo: true,
    };
  },
  watch: {
    currentTab() {
      switch (this.currentTab) {
        case 1:
          this.currentComponent = "recommendCourse";
          break;
        case 2:
          this.currentComponent = "coursePlaza";
          break;
        case 3:
          this.currentComponent = "learnRecords";
          break;
        default:
          break;
      }
    },
  },

  mounted() {},

  methods: {
    toPlaza(name) {
      // console.log("2222222", name);
      this.type = name;
      this.currentTab = 2;
    },
    search(keyword) {
      if (this.keyword.length == 0 && keyword.length == 0) return;
      this.keyword = keyword;
      if (this.currentTab !== 3) {
        this.currentTab = 2;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
